export default [
  {
    path: 'botpress',
    name: 'MonitoramentoChatBot',
    component: require('./Read').default,
    meta: { middleware: 'auth', controller: 'BotPressController' },
  },
  {
    path: 'botpress/conversa/:conversation_id/:conversation_id_suas',
    name: 'VisualizarConversa',
    component: require('./VisualizarConversa').default,
    meta: { middleware: 'auth', controller: 'BotPressController' },
    props: true,
  },
];
